<div >
    <h5>embed whit local url</h5>
    <embed [attr.data]="dataLocalUrl" type="application/pdf" width="100%" height="100%">
</div>